import { useState, useEffect } from 'react'
import { useParams } from "react-router"
import SearchField from 'react-search-field';
import EditProfileName from './EditProfileName'
import EditProfileSettings from './EditProfileSettings'
import AccessModel from './AccessModel'
import EditUserProfile from './EditUserProfile'
import AddUser from './AddUser'
import './dp.css'
import ContentSelector from '../../ContentSelector'


const EditProfile = ({language, setBreadcrumbObject}) => {
    let { profileId } = useParams();
    const [searchTypeHeader, setSearchTypeHeader] = useState(language.value === "DA" ? "Adgang" : "Access")
    const [viewType, setViewType] = useState('access')
    const [profile, setProfile] = useState()
    const [profileName, setProfileName] = useState()
    const [showSaveProfileBtn, setShowSaveProfileBtn] = useState(false)
    const [profileList, setProfileList] = useState()
    const [users, setUsers] = useState()
    const [access, setAccess] = useState()
    const [list, setList] = useState()
    const [accessModel, setAccessModel] = useState()
    const [editor, setEditor] = useState()
    const [showAddEditor, setShowAddEditor] = useState(false)
    const [showAddAccess, setShowAddAccess] = useState(false)

    useEffect(() => {
          
        const getData = async () => {
            const data = await fetchData()
            setProfile(data.profile)
            setProfileName(data.profile.profileName)
            setUsers(data.profile.editors)
            setAccess(data.profile.access)
            setList(data.profile.access)
            setProfileList(data.profiles)
            setBreadcrumbObject({type: (language.value === "DA" ? "Profil: " : "Profile: "), name: data.profile.profileName, link: '', linkText: ''})
        }
      
          getData()
    },[language, profileId])

    const fetchData = async () => {

        var graphql = JSON.stringify({
            query: `query {
                        profile(id:${profileId}) {
                            id
                            solutionId
                            profileName
                            isReadonly
                            hasAccessToSettings
                            hasAccessToModels
                            hasAccessToProfiles
                        
                            editors{
                                id
                                editorName
                                editorEmail
                                editorPwd
                                profileId
                            }
                            access{
                                id
                                profileId
                                accessCreate
                                accessDraft
                                accessPublish
                                accessDelete
                                contentModel{
                                    id
                                    modelName
                                }
                                contentTypes{
                                    id
                                    contentTypeName
                                }
                            }
                        }
                        profiles{
                            id
                            profileName
                        }
                    }`,
            variables: {}
          })
        const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
            method:'POST',
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: graphql
        })
        .then(response => response.text())
        .then(result => {return JSON.parse(result).data})
        .catch(error => console.log('error', error))
        const data = await res
        return data
    }

    const handleSearch = (keyword) => {
        if(viewType === 'users'){
            setList(users.filter((user) => user.editorName.toLowerCase().includes(keyword.toLowerCase()) || user.editorEmail.toLowerCase().includes(keyword.toLowerCase())))
        }
    }

    const setUpdatedEditor = (editor) => {
        if(profileId !== editor.profileId){
            const removeList = users.filter(item => item.id !== editor.id)
            setUsers(removeList)
            setList(removeList)
            setEditor()
        }else{
            const updateList = users.map((item) => {
                if (item.id === editor.id) {
                    return editor;
                }
                return item;
            });
            setUsers(updateList)
            setList(updateList)
        }
    }

    const handleShowViewType = async e => {
        let type = (viewType === 'users' ? 'access' : 'users')
        if(type === 'users'){
            setSearchTypeHeader(language.value === "DA" ? "Brugere" : "Users")
            setList(users)
            setAccessModel()
        }
        if(type === 'access'){
            setSearchTypeHeader(language.value === "DA" ? "Adgang" : "Access")
            setList(access)
            setEditor()
        }
        setViewType(type)
    }

    const handleAddEditorShow = async e => {
        e.preventDefault();
        setShowAddEditor(showAddEditor ? false : true)
    }
    const handleAddAccessShow = async e => {
        e.preventDefault();
        setShowAddAccess(showAddAccess ? false : true)
    }

    const handleAddContentModels = async (contentModels) => {
        contentModels.forEach(async item => {
            const data = await postAccess(item)
            setAccess([...access, data.postAccess])
            setList([...access, data.postAccess])
        });
    }

    const postAccess = async (contentModel) => {
        var graphql = JSON.stringify({
            query: `mutation ($profileId: Long, $contentModelId: Long, $accessCreate: Boolean, $accessDraft: Boolean, $accessPublish: Boolean, $accessDelete: Boolean){
                        postAccess(profileId:$profileId, contentModelId: $contentModelId, accessCreate: $accessCreate, accessDraft: $accessDraft, accessPublish: $accessPublish, accessDelete: $accessDelete) {
                            id
                            profileId
                            accessCreate
                            accessDraft
                            accessPublish
                            accessDelete
                            contentModel{
                                id
                                modelName
                            }
                            contentTypes{
                                id
                                contentTypeName
                            }
                        }
                    }`,
            variables: {
                "profileId" : profileId
                , "contentModelId" : contentModel.id
            }
          })
        const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
            method:'POST',
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: graphql
        })
        .then(response => response.text())
        .then(result => {return JSON.parse(result).data})
        .catch(error => console.log('error', error))
        const data = await res
        return data
    }
    
    const setSelectedAccess = async (id) => {
        if(id !== 0){
            var access = list.filter((item) => item.id === id)[0]
            setAccessModel(access)
        }else{
            setAccessModel()
        }
    }

    let content;

    if (list) {
        content = (
            <div id="cc_profile_editcontainer">
                <div id="cc_profile_item">
                {(profile) && <EditProfileName language={language} profile={profile} setProfile={setProfile} profileName={profileName} setProfileName={setProfileName} setShowSaveProfileBtn={setShowSaveProfileBtn} />}
                    <div id="cc_profile_list_filter" className="cc_list_filter">
                        <div className="filter-block">
                            <span>
                                {language.value === 'DA' ? `Søg efter ${searchTypeHeader}` : `Search for ${searchTypeHeader}`}
                            </span>
                            
                            <SearchField classNames="searchInput" onChange={handleSearch} placeholder={language.value === 'DA' ? `Søger i ${searchTypeHeader}` : `Search in ${searchTypeHeader}`} />
                        </div>
                        <div className="filter-block">
                            <span>&nbsp;</span>
                            <div className="btn-group">
                                <button onClick={handleShowViewType} disabled={viewType === 'access'} className={`cc-btn ${viewType === 'access' ? "active" : ""}`}>{language.value === 'DA' ? 'Adgang' : 'Access'}</button>
                                <button onClick={handleShowViewType} disabled={viewType === 'users'} className={`cc-btn ${viewType === 'users' ? "active" : ""}`}>{language.value === 'DA' ? 'Brugere' : 'Users'}</button>
                            </div>
                        </div>
                        <div className="filter-block">
                            <span>&nbsp;</span>
                            <div className="btn-group">
                                {viewType === 'users' && <button onClick={handleAddEditorShow} className="cc-btn blue-gradient">{language.value === 'DA' ? 'Tilføj ny bruger' : 'Add new user'}</button> }
                                {viewType === 'access' && <button onClick={handleAddAccessShow} className="cc-btn blue-gradient">{language.value === 'DA' ? 'Tilføj adgang' : 'Add access'}</button> }
                            </div>
                        </div>
                    </div>  
                    <div id="cc_profile_item_list" className="cc_item_list">
                        {(list.length === 0 && viewType === 'access') && <div><h3>{language.value === "DA" ? "Der er ingen begrænsninger" : "There are no restrictions"}</h3></div>}
                    {
                        list.map((item) => (
                                ((viewType === 'users') ? <label className="list-item" onClick={()=> setEditor(editor !== item ? item : null)}><span>{item.editorName}</span><small>{item.editorEmail}</small></label>
                                :
                                <label className="list-item" onClick={() => setSelectedAccess(accessModel !== item ? item.id : 0)}><span>{item.contentModel.modelName}</span></label>)
                                
                        ))
                    }
                    </div>
                </div>
            <div id="cc_info_panel" className="scrollable">
                {(profile && !editor && !accessModel) && <EditProfileSettings language={language} profile={profile} setProfile={setProfile} profileName={profileName} showSaveProfileBtn={showSaveProfileBtn} setShowSaveProfileBtn={setShowSaveProfileBtn} />}
                {(editor) && <EditUserProfile editor={editor} language={language} profiles={profileList} setUpdatedEditor={setUpdatedEditor} showProfileLink={false} />}
                {(accessModel) && <AccessModel access={accessModel} language={language} />}
            </div>
            <AddUser language={language} isVisible={showAddEditor} setIsVisible={setShowAddEditor} profileId={profileId} users={users} setUsers={setUsers}/>
            
            <ContentSelector language={language}
                                type={'contentModels'}
                                isVisible={showAddAccess}
                                setIsVisible={setShowAddAccess}
                                callback={handleAddContentModels}/>
        </div>)
    }


    return (
        <>
          {content}
        </>
    )
}

export default EditProfile
